import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import useScrollToElement from '../../../../hooks/dom/useScrollToElement';
import { createForm } from '../../../../models/Form';
import { createFormField } from '../../../../models/FormField';
import { modelOf } from '../../../../prop-types';
import CheckoutStore from '../../../../store/CheckoutStore';
import FormFieldType from '../../../../types/FormFieldType';
import { createOption } from '../../../form/Field';
import MethodImage from '../../../common/MethodImage';
import CheckoutMethodSelector from '../../common/CheckoutMethodSelector';

const CheckoutPaymentMethodContent = ({
  checkoutStore,
  onOrderUpdate,
  content,
}) => {
  const { order } = checkoutStore;
  const { scroll_to_method, selected_payment } = order;
  const group = selected_payment?.group;
  const id = group
    ? `CheckoutPaymentMethodContent-${group.type}`.toLowerCase()
    : null;
  const [ref] = useScrollToElement({
    elementIdToScroll: scroll_to_method,
    behavior: 'smooth',
    block: 'center',
  });

  const form = content
    ? null
    : useMemo(
        () =>
          createForm(
            {
              paymentMethodGroup: createFormField({
                type: FormFieldType.BOOLEAN,
                value: selected_payment?.method?.id || null,
                required: false,
              }),
            },
            'PaymentMethodForm'
          ),
        [selected_payment?.method?.id]
      );

  const createOptions = () => {
    return order.selectedPaymentGroupMethods.map((method) =>
      createOption({
        value: method.id,
        label: (
          <div className="CheckoutPaymentMethod__selector">
            {method.logo && (
              <MethodImage method={method} variant="checkout-method-card" />
            )}
            <div className="CheckoutPaymentMethod__selector-description">
              <p>{method.name}</p>
            </div>
          </div>
        ),
      })
    );
  };

  const updatePaymentMethod = (method) => {
    order.updateSelectedPayment({ paymentMethodId: method.value });
    onOrderUpdate({ withoutTimer: true });
  };

  const renderContent = () => {
    if (content) {
      return content;
    }

    return (
      <CheckoutMethodSelector
        form={form}
        field={'paymentMethodGroup'}
        fieldName={'paymentMethodGroup'}
        onChange={updatePaymentMethod}
        options={createOptions()}
      />
    );
  };

  return (
    <div ref={ref} className="CheckoutPaymentMethodContent" id={id}>
      {renderContent()}
    </div>
  );
};

CheckoutPaymentMethodContent.propTypes = {
  checkoutStore: modelOf(CheckoutStore).isRequired,
  onOrderUpdate: PropTypes.func,
  content: PropTypes.node,
};

export default inject('checkoutStore')(observer(CheckoutPaymentMethodContent));
